<template>
    <v-container style="padding-top:70px" width="100%">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row width="100%">
            <v-col cols="12" md="6">
                <v-card class="text-xs-center" width="100%">
                    <v-card-title @click="mostrar()" class=" primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-filter</v-icon>
                        <span class="card-title-text" style="color: white;">Filtros</span>
                        <v-spacer></v-spacer>
                        <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-card-title>
                    <v-expand-transition>
                        <div v-if="show">
                            <v-card-text class="cardProduct">

                                <v-card-text class="font-weight-bold"> Establece los criterios de busqueda (Los 2 campos son obligatorios):</v-card-text>

                                <v-row>
                                    <v-col cols="12">
                                        <label class="typo__label" style="text-align: center;">Cliente:</label>
                                        <multiselect v-model="clienteSelect" deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor"
                                                     track-by="clclave" label="clnombre" placeholder="Seleccionar Cliente"
                                                     :options="clientes" :allow-empty="true">

                                        </multiselect>

                                    </v-col>
                                </v-row>





                                <v-row>
                                    <v-col cols="12">
                                        
                                        <label class="typo__label" style="text-align: center;">Producto:</label>

                                        <multiselect :disabled="clienteSelect == ''" v-model="producSelect" deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor"
                                                     track-by="dpclave" label="dpnombre" placeholder="Seleccionar Cliente"
                                                     :options="productos" :allow-empty="true">

                                        </multiselect>

                                    </v-col>
                                </v-row>


                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card class="text-xs-center" width="100%">
                    <v-card-title @click="mostrarObs()" class=" primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-eye</v-icon>
                        <span class="card-title-text" style="color: white;">Observación</span>
                        <v-spacer></v-spacer>
                        <v-icon :color="'#FFFFFF'">{{ showObs ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-card-title>
                    <v-expand-transition>
                        <div v-if="showObs">
                            <v-card-text class="cardProduct">


                                <v-container v-if="obsSelect != ''">

                                    <v-card-text class="font-weight-bold"> {{obsSelect}}</v-card-text>

                                </v-container>


                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>

            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card flat class="text-xs-center" width="100%">
                    <v-card-title class=" primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-information-outline</v-icon>
                        <span class="card-title-text" style="color: white;">Consulta Productos</span>
                    </v-card-title>
                    <v-card-text>

                        <v-container v-if="detallesTable">
                            <DataTable :url="url"
                                       :columns="head"
                                       :params="displayInputs"
                                       :order="[]"
                                       :formatterActions="formatterActions"
                                       @apiDT="apiDT = $event">

                            </DataTable>

                        </v-container>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import moment from "moment";
    import General from "@/services/Operacion/Operacion.service.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Utilidades from '@/services/Utilidades/Utilidades.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                clientes: [],
                productos: [],
                clienteSelect: '',
                producSelect: '',
                obsSelect: '',
                detallesTable: false,
                apiDT: null,
                show: true,
                showObs:true,
                validForm: true,
                showcargando: true,

                busqueda: {
                    aseguradora: '',
                    producto: '',

                },
                rules: {
                    required: value => !!value || 'Campo requerido',
                },

                displayInputs:
                {
                    cliente: '',
                    cveproducto: 0,
                },
                url: "Utilidades/ProductosDetalle",
                head: [
                    /*{ name: "Reporte", data: "Reporte", title: "Reporte", formatter: [this, "detalleReporte"], },*/

                    { name: "ptdesc", data: "ptdesc", title: "Prestación" },
                    { name: "pdeventos", data: "pdeventos", title: "Eventos" },
                    { name: "pdlimite", data: "pdlimite", title: "Limite" },
                    { name: "pdunidad", data: "pdunidad", title: "Unidad" },
                    { name: "pdobsprest", data: "pdobsprest", title: "Obs. Prest." },
                    { name: "pdobsasist", data: "pdobsasist", title: "Obs. Asist." },
                    { name: "pdmodificaprest", data: "pdmodificaprest", title: "Modif. Prest." },
                    { name: "ainombre", data: "ainombre", title: "Asistencia" },
                    { name: "pdcontrato", data: "pdcontrato", title: "Contrato", formatter: [this, "checkForm"] },

                ],
                formatterActions: [
                    /* <input type="checkbox" disabled checked />*/
                    { click: [this, "BuscarReporte"] },
                ],
                checkForm(datos) {
                    if ((datos.pdcontrato == true)) {

                        return `<div class="text-center"><input class="custom-control-input" type="checkbox" style="pointer-events: none;" checked /></div>`;
                    } else {
                        return `<div class="text-center"><input class="custom-control-input" type="checkbox" style="pointer-events: none;" /></div>`;
                    }
                },

            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        watch: {
            clienteSelect(val) {
                this.displayInputs.cliente = '';
                this.displayInputs.cveproducto = '';
                this.detallesTable = false;
                this.producSelect = '';
                this.obsSelect = '';

                this.displayInputs.cliente = val.clclave;
                this.ObtenerProductos(val.clclave);
            },
            async producSelect(val) {

                if (this.producSelect != '') {

                    this.displayInputs.cveproducto = val.dpclave;
                    this.detallesTable = true;
                    var desObs = await Utilidades.ObtenerObservacionesProducto(this.displayInputs.cliente, this.displayInputs.cveproducto);
                    this.obsSelect = desObs;
                    this.reloadTable();
                }

            },


        },
        async mounted() {
            this.showcargando = false;

            var dataCliente = await Utilidades.ObtenerClientes();
            this.clientes = dataCliente.data;
        },
        methods: {
            async ObtenerProductos(clclave) {
                var dataProducto = await Utilidades.ObtenerProductos(clclave);
                this.productos = dataProducto.data;
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            mostrar() {
                if (this.show == true) {
                    this.show = false;

                } else {
                    this.show = true;
                    
                }
            },
            mostrarObs() {
                if (this.showObs == true) {
                    this.showObs = false;

                } else {
                    this.showObs = true;
                    
                }
            }
        },
        async beforeMount() {

        }
    }
</script>
<style scoped>

    .cardProduct {
        height: 300px;
    }

    @media screen and (max-width: 600px) {
        .cardProduct {
            height: auto;
        }
    }
</style>